import { render, staticRenderFns } from "./appointStep1.vue?vue&type=template&id=08ea0bb8&scoped=true"
import script from "./appointStep1.vue?vue&type=script&lang=js"
export * from "./appointStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea0bb8",
  null
  
)

export default component.exports